import { COMPANY } from "@/data/site";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#F5F1EA] border-t border-[#C9C3B4]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-12">
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <img src="/logo/tavas-mark.png" alt="Tavas" className="h-9 w-auto" />
              <span className="font-display font-800 tracking-tighter text-lg">
                TAVAS<span className="text-[#0055FF]">.</span>
              </span>
            </div>
            <p className="font-display font-800 tracking-tighter text-3xl md:text-5xl leading-[0.95] max-w-xl">
              Precision moulded plastics,
              <span className="text-[#55524B]"> for every industry.</span>
            </p>
          </div>
          <a
            href="#quote"
            data-testid="footer-cta"
            className="btn-industrial inline-flex items-center gap-3 border border-[#0055FF] text-[#0055FF] hover:bg-[#0055FF] hover:text-white px-8 py-4 font-mono-tech text-xs uppercase tracking-widest shrink-0"
          >
            Start a Project
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 pt-10 border-t border-[#C9C3B4]">
          <div>
            <span className="font-mono-tech text-[10px] uppercase tracking-widest text-[#0055FF]">Contact</span>
            <p className="text-[#55524B] text-sm mt-3">{COMPANY.email}</p>
            <p className="text-[#55524B] text-sm">{COMPANY.phone}</p>
          </div>
          <div>
            <span className="font-mono-tech text-[10px] uppercase tracking-widest text-[#0055FF]">Location</span>
            <p className="text-[#55524B] text-sm mt-3 max-w-xs">{COMPANY.address}</p>
          </div>
          <div>
            <span className="font-mono-tech text-[10px] uppercase tracking-widest text-[#0055FF]">Capabilities</span>
            <p className="text-[#55524B] text-sm mt-3">Injection Moulding · Thin-Wall Packaging · Custom Job Production</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-14 pt-8 border-t border-[#C9C3B4]">
          <span className="font-mono-tech text-[10px] uppercase tracking-widest text-[#9B9689]">
            © {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.
          </span>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-mono-tech text-[10px] uppercase tracking-widest text-[#9B9689] hover:text-[#0055FF] transition-colors"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
